var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 53,
    viewBox: "0 0 83 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HJ85nT"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.2886 52.4195C28.4076 52.4195 15.5281 52.4195 2.64703 52.4163C2.25608 52.4163 1.85566 52.4068 1.47574 52.3292C0.655994 52.1613 0.101089 51.5102 0.0159614 50.6802C-0.00295581 50.498 0.000197054 50.3111 0.000197054 50.1273C0.000197054 34.5225 0.000197054 18.9162 0.000197054 3.3114C-0.00137938 1.66554 0.700134 0.957454 2.35066 0.957454C28.3477 0.954286 54.3447 0.954286 80.3432 0.957454C81.8945 0.957454 82.7111 1.77959 82.7111 3.36209C82.7158 18.9415 82.7158 34.521 82.7111 50.0988C82.7111 51.7605 82.0048 52.4179 80.2455 52.4179C67.2604 52.4195 54.2737 52.4179 41.2886 52.4179V52.4195ZM67.5662 46.4063C67.3471 43.8259 68.1117 41.6905 69.9782 40.0082C71.8463 38.3243 74.0911 37.9457 76.5094 38.2927V16.0775C73.8468 16.5686 71.5373 15.9825 69.644 14.0927C67.7286 12.1807 67.2573 9.79663 67.6324 7.17814H14.4766C14.7147 9.65089 14.1645 11.8401 12.4146 13.6063C10.6727 15.3647 8.50507 15.9492 6.05844 15.7496V37.8254C8.51295 37.6036 10.6695 38.1944 12.4162 39.9623C14.1787 41.746 14.7162 43.9573 14.4813 46.4095H67.5678L67.5662 46.4063Z",
    fill: "url(#paint0_linear_1_2359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.3723 10.9261C49.967 10.9451 57.0247 18.0608 57.0184 26.7019C57.0121 35.3779 49.9875 42.4429 41.3628 42.4477C32.7145 42.4524 25.6615 35.3447 25.6773 26.6417C25.693 17.9847 32.7634 10.9055 41.3723 10.9261ZM46.1615 20.3482C43.9229 22.6055 41.634 24.9151 39.2488 27.3213C38.2651 26.2774 37.3334 25.2889 36.4853 24.3892C35.4196 25.4616 34.4423 26.4437 33.5232 27.3688C35.4323 29.2792 37.3933 31.2435 39.2488 33.1016C42.5262 29.8416 45.8541 26.534 49.1047 23.3025C48.1525 22.3473 47.1767 21.3652 46.1615 20.3466V20.3482Z",
    fill: "url(#paint1_linear_1_2359)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2359",
    x1: 41.2055,
    y1: -7.35725,
    x2: 41.24,
    y2: 52.4196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2359",
    x1: 41.2903,
    y1: 5.83477,
    x2: 41.3245,
    y2: 42.4477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.e99b4391168afd3fe04105e158726787.svg";
export { ForwardRef as ReactComponent };